<template>
  <div style="overflow:hidden;" class="mainbox">
    <div class="contactbanner" :style="{height:250+'px','background': 'url('+ contactban +') no-repeat center center', 'background-size': '100% 100%'}"></div>

    <div class="contactbox">
        <div class="contactus">
            <h3>联系和了解我们</h3>
            <div class="contactusbox">
              <p>PKzoo.com，致力于测评推荐收录分享发现一些优秀的的网站/应用，全网精品应用推荐导航。</p>
<p>大千世界犹如浩瀚的动物园，每个网站/应用犹如这世界食物链里的生物。动物园里有才华横溢的设计狮，富有创造力的程序猿，用心市场洞察的产品汪，嗅觉灵敏的运营喵，还有一群群牛马等...他们都在各自领域闪耀着光芒。PKzoo希望通过共同测评、探索共同发现的分享方式，能使缺乏名气流量但又优秀有价值+"美味"的应用浮现在用户面前，收录具有实用价值的网站/应用。</p>
<br/>
<p>最后，希望大家一起干了这碗“安利”。</p>
<br/>
<p>请通过以下方式联系我们：）</p>

<p>联系或者举报违法不良信息：15159512107</p>

            </div>
        </div>

      <div class="partner">
          <h3>标签合伙人计划</h3>
          <div class="partnerbox">
            <p>计划招募有志合伙人，且标对标签词类十分了解或者相关行业从业者。共同管理维护标签词类，丰富内容，打造成为权威标签内容分类平台。</p>
          </div>
      </div>


      <div class="helpus">
          <h3>帮助我们成为更好</h3>
          <div class="helpusbox">
              <dl class="alipaydl">
                  <dt><img :src="alipaypic"/></dt>
                  <dd><img :src="alipaycode"/></dd>
              </dl>

              <dl class="wechatpaydl">
                  <dt><img :src="wechatpaypic"/></dt>
                  <dd><img :src="wechatpaycode"/></dd>
              </dl>


          </div>
      </div>



    </div>



    <div class="footerbox"></div>
    <!-- <div class="addwebbox">
      <addweb></addweb>
    </div> -->
    <BackTop :bottom="200" :right="25"></BackTop>
  </div>
</template>

<script>
import addweb from "../publish/addweb";
export default {
  components: { addweb },
  data() {
    return {
      contactban: require("@/assets/images/contactban.jpg"),
      alipaypic: require("@/assets/images/alipaypic.gif"),
      alipaycode: require("@/assets/images/alipaycode.png"),
      wechatpaypic: require("@/assets/images/wechatpay.gif"),
      wechatpaycode: require("@/assets/images/wechatpaycode.png"),
    };
  },
  created(){
    window.scrollTo(0,0);
  },
  mounted(){
    
  },
  methods:{
    gotolabeldetails(){
      this.$router.push({
        name:'labeldetails'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.mainbox{}
.contactbox{
  max-width: 1220px; margin: 0 auto; padding-bottom: 50px;
   .contactus{ padding-top: 35px;
      h3{ font-size: 20px; color: #333;padding-bottom: 30px;}
      .contactusbox{
         p{ font-size: 14px; line-height: 26px; color: #666;}
      }
  }

  .partner{ padding-top: 80px;
      h3{ font-size: 20px; color: #333;padding-bottom: 30px;}
      .partnerbox{
         p{ font-size: 14px; line-height: 26px; color: #666;}
      }
  }

  .helpus{padding-top: 80px;
    h3{ font-size: 20px; color: #333;padding-bottom: 30px;}
   .helpusbox{ padding-top: 30px;
      dl{ float: left; margin-right: 30px; position: relative; cursor: pointer;
          dd{ position: absolute; top:-330px; left: -35px; display: none;}
      
      }

      .alipaydl:hover{
          dd{ display: block;}
      }

      .wechatpaydl:hover{
          dd{ display: block;}
      }


   }

    }
}

.footerbox {
  height: 60px;
}

.addwebbox {
  right: 30px;
  position: fixed;
  top: 38%;
}
@media screen and (max-width: 1300px) {  
  .addwebbox {
    right: 15px;
    position: fixed;
    top: 38%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/pages/contact.vue